import React from 'react';

type StatusType =
  | 'In Transit' |'Arrived at POD' |'Customs Hold' |'Discharged' |'Booking Confirmed' |'Cargo Received' |'Vessel Departed' |'Delivery Order Issued' |'Delayed' |'Active' |'Triggered' |'Paused';

const statusMap: Record<string, string> = {
  'In Transit': 'status-in-transit',
  'Arrived at POD': 'status-arrived',
  'Customs Hold': 'status-customs',
  Discharged: 'status-discharged',
  'Booking Confirmed': 'status-booked',
  'Cargo Received': 'status-booked',
  'Vessel Departed': 'status-in-transit',
  'Delivery Order Issued': 'status-arrived',
  Delayed: 'status-delayed',
  Active: 'status-arrived',
  Triggered: 'status-in-transit',
  Paused: 'status-booked',
};

export default function StatusBadge({
  status,
  size = 'sm',
}: {
  status: string;
  size?: 'xs' | 'sm' | 'md';
}) {
  const cls = statusMap[status] || 'status-booked';
  const sizeClass =
    size === 'xs' ?'text-xs px-1.5 py-0.5'
      : size === 'md' ?'text-sm px-3 py-1' :'text-xs px-2 py-0.5';

  return (
    <span className={`inline-flex items-center rounded-full font-semibold ${cls} ${sizeClass}`}>
      {status}
    </span>
  );
}